import Map from './component';

export default Map;
